var map = {
	"./IBM_logo.svg": 957,
	"./Lfhs.png": 898,
	"./Parle.svg": 775,
	"./SecurityImage.png": 138,
	"./SecurityImage2.png": 586,
	"./SecurityImage3.png": 811,
	"./ShieldonLogo.jpg": 910,
	"./ShieldonTitle.jpg.png": 626,
	"./Swiss_castle_bakery.png": 216,
	"./Yamaha_logo.svg": 410,
	"./dtdc.png": 484,
	"./meta.png": 268,
	"./nichino.png": 737,
	"./volvo.png": 121
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 379;